import React from 'react';

import styles from './agreement.module.scss';
import Checkbox from '../checkbox/checkbox';

interface AgreementProps {
  onChange: (event:React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
  name: string;
  id: string;
  checked: boolean;
}

export default function CustomAgreement(props:AgreementProps) {
	const { onChange, name, label, checked, id } = props;

	return (<div className={styles.agreementContainer}>
		<span className={styles.agreement}>
			<input 
				name={name} 
				id={id}
				type='checkbox' 
				checked={checked}
				onChange={onChange}
			/>
			<label htmlFor={id}>
				<Checkbox kind='agreement' checked={checked}/>
			  {label}
			</label>
		</span>
  </div>);
}